export function getImageUrlPublic(filename, teamId) {
  // Get the extension of a file
  // console.log('Inside getImageUrlPublic', filename, teamId)
  const { env } = require('../env.js')
  let domainLogo = ''
  switch (env) {
    case 'prod':
      domainLogo = 'vendictbeta-customer-logos'
      break
    case 'dev':
      domainLogo = `vendictdev-customer-logos`
      break
    case 'qa':
      domainLogo = `vendictqa-customer-logos`
      break
  }

  let res = `https://storage.googleapis.com/${domainLogo}/${teamId}/${filename}?id=${Date.now()}`
  // console.log('Inside getImageUrlPublic', res)
  return res
}
